import GenericContentPage from 'components/ui/genericContentPage/GenericContentPage'
import { SnackbarContext } from 'components/ui/snackbar/context/Snackbar'
import React, { useContext, useEffect, useState } from 'react'
import { Container } from 'reactstrap'
import reportsApi from 'services/reportsApi'
import { Filter } from 'Types/Filter'
import { ReportTimeTrack } from 'Types/Reports/ReportTimeTrack'
import ReportsSkeleton from './ReportsSkeleton'
import ReportsTimeTrack from './ReportsTimeTrack'
import ReportsFilters, { periodFilters } from './ReportsFilters'
import moment from 'moment'
import styles from './styles.module.scss'
import exportPdfIcon from 'assets/img/damir.png'

const ReportsLayout: React.FC = () => {
  const snackbarContext = useContext(SnackbarContext)
  const [loading, setLoading] = useState<boolean>(true)
  const [exporting, setExporting] = useState<boolean>(false)
  const [timeTrackReports, setTimeTrackReports] = useState<ReportTimeTrack[]>([])
  const [filters, setFilters] = useState<Filter[]>(() => periodFilters(moment(), 'month'))

  const getFilter = (key: string) => filters.find((filter) => filter.key === key)
  const projectFilter = getFilter('projectId')

  useEffect(() => {
    if (filters.length > 0) {
      getTimeTrackReports()
    }
  }, [filters])

  function getTimeTrackReports() {
    reportsApi.getTimetracksReports(filters).then((response) => {
      setTimeTrackReports(response)
      setLoading(false)
    })
  }

  function exportPdf() {
    const startDate = getFilter('startDate')?.value
    const endDate = getFilter('endDate')?.value
    if (!projectFilter?.value || !startDate || !endDate) {
      return
    }

    setExporting(true)
    reportsApi
      .exportWorkingHours(projectFilter.value, startDate, endDate)
      .then((response: any) => {
        const downloadLink = document.createElement('a')
        downloadLink.href = `data:application/pdf;base64,${response.base64}`
        downloadLink.download = `${projectFilter.label} - brainit - ${startDate} - ${endDate}.pdf`
        downloadLink.click()
      })
      .catch((e: Error) => snackbarContext?.setShowSnackbarData(true, e.message, 'danger'))
      .finally(() => setExporting(false))
  }

  return (
    <Container>
      {/* generic content page sets same header layout and renders different content as React FC */}
      <GenericContentPage
        header={{
          title: 'Reports',
          actions: (
            <span
              className={styles.exportWrapper}
              title={projectFilter ? undefined : 'Select a project to export its working hours'}
            >
              <button
                className="addButton secondary"
                type="button"
                onClick={exportPdf}
                disabled={!projectFilter || exporting}
              >
                <img className={styles.exportIcon} src={exportPdfIcon} alt="" />
                {exporting ? 'Exporting…' : 'Export PDF'}
              </button>
            </span>
          ),
        }}
      >
        <>
          <ReportsFilters filters={filters} setFilters={setFilters} />
          {loading ? <ReportsSkeleton /> : <ReportsTimeTrack timeTrackReports={timeTrackReports} />}
        </>
      </GenericContentPage>
    </Container>
  )
}

export default ReportsLayout
